import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";

function fmt(d) {
  try {
    return new Date(d).toLocaleDateString("en-GB", { day: "numeric", month: "long", year: "numeric" });
  } catch { return ""; }
}

export default function Journal() {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/journal").then((r) => setPosts(r.data)).catch(() => {}).finally(() => setLoading(false));
  }, []);

  const [first, ...rest] = posts;

  return (
    <div data-testid="journal-page">
      <section className="hm-container pt-40 pb-24 md:pb-28">
        <p className="hm-eyebrow mb-8">Journal</p>
        <h1 className="font-display leading-[0.98] tracking-[-0.02em] max-w-4xl" style={{ fontSize: "clamp(44px, 6.4vw, 92px)", fontWeight: 400 }}>
          Notes from the work.
        </h1>
        <p className="mt-10 text-[color:var(--hm-ink-dim)] text-[17px] max-w-2xl leading-relaxed">
          Short writing on regenerative development, the projects we&rsquo;re working on, and the language we use to describe them.
        </p>
      </section>

      <section className="hm-container pb-24">
        {loading && <p className="text-[color:var(--hm-ink-dim)]">Loading…</p>}
        {!loading && posts.length === 0 && (
          <p className="text-[color:var(--hm-ink-dim)]">No entries yet.</p>
        )}

        {first && (
          <Link to={`/journal/${first.slug}`} className="block group" data-testid="journal-featured">
            <div className="grid md:grid-cols-12 gap-12 mb-24">
              <div className="md:col-span-7">
                {first.cover_image && (
                  <div className="aspect-[16/10] overflow-hidden">
                    <img src={first.cover_image} alt="" className="w-full h-full object-cover transition-transform duration-[900ms] group-hover:scale-105" />
                  </div>
                )}
              </div>
              <div className="md:col-span-5 flex flex-col justify-center">
                <p className="hm-eyebrow mb-4">Latest · {fmt(first.created_at)}</p>
                <h2 className="font-display leading-[1.05] mb-6" style={{ fontSize: "clamp(30px, 3.6vw, 52px)", fontWeight: 400 }}>{first.title}</h2>
                <p className="text-[color:var(--hm-ink-dim)] text-[17px] max-w-xl leading-relaxed">{first.excerpt}</p>
                <span className="hm-eyebrow mt-7 group-hover:text-[color:var(--hm-pink)] transition-colors">Read entry →</span>
              </div>
            </div>
          </Link>
        )}

        <div className="hm-rule mb-14" />

        <div className="grid md:grid-cols-3 gap-10">
          {rest.map((p, i) => (
            <Link key={p.id} to={`/journal/${p.slug}`} className="block group" data-testid={`journal-card-${i}`}>
              {p.cover_image && (
                <div className="aspect-[4/3] overflow-hidden mb-6">
                  <img src={p.cover_image} alt="" className="w-full h-full object-cover transition-transform duration-[900ms] group-hover:scale-105" />
                </div>
              )}
              <p className="hm-eyebrow mb-4">{fmt(p.created_at)}</p>
              <h3 className="font-display text-[24px] leading-snug mb-3 group-hover:text-[color:var(--hm-pink)] transition-colors" style={{ fontWeight: 400 }}>{p.title}</h3>
              <p className="text-[color:var(--hm-ink-dim)] text-[14.5px] leading-relaxed">{p.excerpt}</p>
            </Link>
          ))}
        </div>
      </section>
    </div>
  );
}
